import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Mail, 
  Linkedin, 
  Twitter, 
  ArrowUp
} from 'lucide-react';

export const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="relative bg-gray-900 text-white">
      
      {/* Simple background */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 to-gray-800"></div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        
        {/* Minimalistic Footer Content */}
        <div className="py-12">
          
          {/* Single row layout */}
          <div className="flex flex-col lg:flex-row justify-between items-center space-y-6 lg:space-y-0">
            
            {/* Left: Logo and Copyright */}
            <div className="flex flex-col lg:flex-row items-center space-y-4 lg:space-y-0 lg:space-x-8">
              <div className="flex items-center space-x-4">
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-2">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_mande-experts/artifacts/z0cnnuyb_Logo-%20Evidentia.jpeg" 
                    alt="Evidentia Logo" 
                    className="h-6 w-auto transition-transform duration-300 hover:scale-105"
                    onError={(e) => {
                      const parent = e.target.parentElement;
                      parent.innerHTML = '<div class="text-lg font-bold text-white">EVIDENTIA</div>';
                    }}
                  />
                </div>
                <div className="text-sm text-gray-400">
                  © 2025 Evidentia Africa Ltd
                </div>
              </div>
            </div>

            {/* Center: Quick Links */}
            <div className="flex items-center space-x-6 text-sm">
              <Link to="/about" className="text-gray-400 hover:text-white transition-colors">About</Link>
              <Link to="/services" className="text-gray-400 hover:text-white transition-colors">Services</Link>
              <Link to="/team" className="text-gray-400 hover:text-white transition-colors">Our Team</Link>
              <Link to="/contact" className="text-gray-400 hover:text-white transition-colors">Contact</Link>
            </div>

            {/* Right: Social Links and Back to Top */}
            <div className="flex items-center space-x-4">
              {/* Social Links */}
              <a 
                href="https://linkedin.com/company/evidentia-africa"
                className="w-8 h-8 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-all duration-300"
              >
                <Linkedin className="w-4 h-4" />
              </a>
              <a 
                href="https://twitter.com/evidentia_africa"
                className="w-8 h-8 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-all duration-300"
              >
                <Twitter className="w-4 h-4" />
              </a>
              <a 
                href="mailto:info@evidentia.africa"
                className="w-8 h-8 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-all duration-300"
              >
                <Mail className="w-4 h-4" />
              </a>
              
              {/* Back to Top */}
              <button
                onClick={scrollToTop}
                className="w-8 h-8 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-all duration-300 group"
              >
                <ArrowUp className="w-4 h-4 group-hover:-translate-y-0.5 transition-transform duration-300" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};